import { logError } from "../../../shared/functions/misc";
import Config from "../../../config";
import m from "mithril";
import User from "@phoenixreisen/user";
export const View = {
    view() {
        const { phoenix, urls } = Config;
        try {
            return (m("article", { class: "error" },
                m("div", { class: "alert alert--danger" },
                    m("h3", { class: "tc" },
                        "Huch, da ist wohl ein Fehler aufgetreten",
                        m("br", null),
                        "\u00AF\\_(\u30C4)_/\u00AF"),
                    m("p", null,
                        "Leider ist w\u00E4hrend der Abfrage Ihrer Buchungsdaten ein unbekannter Fehler aufgetreten.",
                        " ",
                        m("a", { href: urls.OVERVIEW, title: "letzte Seit erneut aufrufen" }, "Bitte versuchen Sie es erneut"),
                        "."),
                    m("p", null,
                        "Sollte der Fehler nicht verschwinden, versuchen Sie es bitte sp\u00E4ter noch einmal oder wenden Sie sich gerne",
                        " ",
                        m("a", { href: `tel:${phoenix.tel}`, title: "Telefonnummer aufrufen" }, "telefonisch an uns"),
                        "."),
                    m("p", null,
                        "F\u00FCr die Unannehmlichkeit bitten wir",
                        " ",
                        m("i", { class: "fas fa-heart ml1 mr1" }),
                        " um Entschuldigung!",
                        m("br", null),
                        "Ihr Team von Phoenix Reisen")),
                m("div", { class: "tr" },
                    m("button", { type: "button", class: "btn--link", onclick: () => {
                            User.logout();
                            m.route.set(urls.LOGIN, undefined, { replace: true });
                        } }, "Zur\u00FCck zur Anmeldung"))));
        }
        catch (e) {
            logError(e);
        }
    },
};
export default View;
